<template>
  <icon-font :type="name" />
</template>
<script lang="ts" setup>
import { createFromIconfontCN } from '@ant-design/icons-vue'

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3433631_y1f51jnrlj.js',
})

defineProps({
  name: {
    type: String,
    required: true,
  },
})

</script>
